import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { resolveAreaLabel, resolveAreaWithPage } from "@/entities/feature-announcement-feedback";
import type { MyFeedbackEntry } from "@/presentation/rpc/feature-announcements-rpc";
import { formatRelativeTime, formatShortDate } from "../lib/format-relative-time";
import { StatusBadge } from "./status-badge";

/**
 * A single ticket row, reused by both the inbox page rail and the widget panel.
 * Selection uses a neutral-grey glow (ambient list, per the design system); the
 * unread dot carries the brand accent.
 */
export function YourFeedbackListRow(t0) {
  const $ = _c(63);
  const {
    item,
    unread,
    selected,
    onClick
  } = t0;
  let t1;
  if ($[0] !== item.comment) {
    t1 = item.comment?.trim();
    $[0] = item.comment;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const comment = t1;
  let t2;
  if ($[2] !== item.featureKey || $[3] !== item.originFeatureKey) {
    t2 = resolveAreaWithPage(item.featureKey, item.originFeatureKey);
    $[2] = item.featureKey;
    $[3] = item.originFeatureKey;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const areaText = t2;
  let t3;
  if ($[5] !== comment || $[6] !== item.featureKey) {
    t3 = comment || `Feedback on ${resolveAreaLabel(item.featureKey)}`;
    $[5] = comment;
    $[6] = item.featureKey;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const title = t3;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[8] !== areaText || $[9] !== comment || $[10] !== item.acknowledgedAt || $[11] !== item.createdAt || $[12] !== item.latestTeamPublicMessageAt || $[13] !== item.status || $[14] !== onClick || $[15] !== selected || $[16] !== title || $[17] !== unread) {
    const teamSignal = unread ? item.latestTeamPublicMessageAt ? {
      label: "Cova replied",
      at: item.latestTeamPublicMessageAt
    } : item.acknowledgedAt ? {
      label: "Seen by Cova",
      at: item.acknowledgedAt
    } : null : null;
    t12 = "button";
    t13 = onClick;
    t14 = selected;
    const t16 = selected ? "bg-white shadow-[0_2px_10px_rgba(71,85,105,0.22)]" : "bg-white/50 hover:bg-white hover:shadow-xs";
    if ($[30] !== t16) {
      t15 = cn("w-full rounded-xl px-3 py-3 text-left outline-hidden transition-all", "focus-visible:ring-2 focus-visible:ring-[#5651ff]/40", t16);
      $[30] = t16;
      $[31] = t15;
    } else {
      t15 = $[31];
    }
    t10 = "flex items-start gap-2";
    if ($[32] !== unread) {
      t11 = unread && <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-red-500" aria-label="Unread" />;
      $[32] = unread;
      $[33] = t11;
    } else {
      t11 = $[33];
    }
    t7 = "min-w-0 flex-1";
    const t17 = unread ? "font-semibold" : "font-medium";
    let t18;
    if ($[34] !== t17) {
      t18 = cn("truncate text-sm text-[#091E42]", t17);
      $[34] = t17;
      $[35] = t18;
    } else {
      t18 = $[35];
    }
    if ($[36] !== t18 || $[37] !== title) {
      t8 = <p className={t18}>{title}</p>;
      $[36] = t18;
      $[37] = title;
      $[38] = t8;
    } else {
      t8 = $[38];
    }
    if ($[39] !== areaText || $[40] !== comment) {
      t9 = comment && <p className="truncate text-xs text-gray-500">{areaText}</p>;
      $[39] = areaText;
      $[40] = comment;
      $[41] = t9;
    } else {
      t9 = $[41];
    }
    t4 = "mt-1.5 flex flex-wrap items-center gap-2";
    if ($[42] !== item.status) {
      t5 = <StatusBadge status={item.status} />;
      $[42] = item.status;
      $[43] = t5;
    } else {
      t5 = $[43];
    }
    t6 = teamSignal ? <span className="text-xs font-medium text-[#091E42]">{teamSignal.label} · {formatRelativeTime(teamSignal.at)}</span> : <span className="text-xs text-gray-500">{formatShortDate(item.createdAt)} · {formatRelativeTime(item.createdAt)}</span>;
    $[8] = areaText;
    $[9] = comment;
    $[10] = item.acknowledgedAt;
    $[11] = item.createdAt;
    $[12] = item.latestTeamPublicMessageAt;
    $[13] = item.status;
    $[14] = onClick;
    $[15] = selected;
    $[16] = title;
    $[17] = unread;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
    $[23] = t15;
    $[24] = t4;
    $[25] = t5;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
    $[29] = t9;
  } else {
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t13 = $[21];
    t14 = $[22];
    t15 = $[23];
    t4 = $[24];
    t5 = $[25];
    t6 = $[26];
    t7 = $[27];
    t8 = $[28];
    t9 = $[29];
  }
  let t16;
  if ($[44] !== t4 || $[45] !== t5 || $[46] !== t6) {
    t16 = <div className={t4}>{t5}{t6}</div>;
    $[44] = t4;
    $[45] = t5;
    $[46] = t6;
    $[47] = t16;
  } else {
    t16 = $[47];
  }
  let t17;
  if ($[48] !== t16 || $[49] !== t7 || $[50] !== t8 || $[51] !== t9) {
    t17 = <div className={t7}>{t8}{t9}{t16}</div>;
    $[48] = t16;
    $[49] = t7;
    $[50] = t8;
    $[51] = t9;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== t10 || $[54] !== t11 || $[55] !== t17) {
    t18 = <div className={t10}>{t11}{t17}</div>;
    $[53] = t10;
    $[54] = t11;
    $[55] = t17;
    $[56] = t18;
  } else {
    t18 = $[56];
  }
  let t19;
  if ($[57] !== t12 || $[58] !== t13 || $[59] !== t14 || $[60] !== t15 || $[61] !== t18) {
    t19 = <button type={t12} onClick={t13} aria-current={t14} className={t15}>{t18}</button>;
    $[57] = t12;
    $[58] = t13;
    $[59] = t14;
    $[60] = t15;
    $[61] = t18;
    $[62] = t19;
  } else {
    t19 = $[62];
  }
  return t19;
}